import { useTheme } from '@/contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import { Sun, Moon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/83824f35-3ffa-4a4b-99df-eb320d1f49ec/images/f7e8960f40cd8a0232b0979111e2b7626e4de012be8e45f7731b894971bd151a.png";

export function AuthShell({ title, subtitle, children, footer }) {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="auth-shell">
      <nav className="w-full border-b border-border">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-3" data-testid="auth-logo-home">
            <img src={LOGO_URL} className="h-8 w-8 rounded-lg" alt="FlipTrack" />
            <span className="font-heading text-xl font-semibold">FlipTrack</span>
          </button>
          <Button variant="ghost" size="icon" onClick={toggleTheme} data-testid="auth-theme-toggle">
            {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <h1 className="font-heading text-3xl font-semibold tracking-tight mb-2">{title}</h1>
            {subtitle && <p className="text-muted-foreground text-sm">{subtitle}</p>}
          </div>
          <div className="rounded-2xl border border-border bg-card p-8 shadow-sm">
            {children}
          </div>
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
